import { Box, Center, Input, Select, Stack } from '@chakra-ui/react';
import { useState } from 'react';
import { Subtipo_inmueble, Tipologia_inmueble } from '../../data/constants';

const FiltroNoticias = ({ setFiltros }) => {
	const [tipologia, setTipologia] = useState('');
	const [subtipologia, setSubtipologia] = useState('');

	const subtiposDisponibles =
		Subtipo_inmueble.find(item => item.tipo === tipologia)?.subtipo || [];

	const handleTipologiaChange = e => {
		const selectedTipologia = e.target.value;
		setTipologia(selectedTipologia);
		setSubtipologia(''); // reset subtipologia al cambiar la tipologia
		setFiltros(e); // actualiza el filtro padre
	};

	const handleSubtipologiaChange = e => {
		setSubtipologia(e.target.value);
		setFiltros(e);
	};

	return (
		<Center>
			<Stack direction='column' spacing={0} align='center'>
				<Box w='100%'>
					<Input
						rounded='none'
						placeholder='Buscar...'
						name='busqueda'
						onChange={setFiltros}
					/>
				</Box>
				<Stack direction='row' spacing={4} align='center' mb={4}>
					<Stack>
						<Select
							size='xs'
							name='personales'
							onChange={setFiltros}
						>
							<option value='personales'>Personales</option>
							<option value='generales'>Generales</option>
						</Select>
					</Stack>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Estado --'
							name='estado'
							onChange={setFiltros}
						>
							<option value='No verificada con propietario'>
								Abierta - no verificada
							</option>
							<option value='Inmueble en el mercado'>
								Abierta - inmueble en mercado
							</option>
							<option value='Cerrada con exito'>
								Cerrada - con éxito
							</option>
							<option value='Cerrada sin exito'>
								Cerrada - sin éxito
							</option>
						</Select>
					</Stack>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Tipología --'
							name='tipologiaInmueble'
							value={tipologia}
							onChange={handleTipologiaChange}
						>
							{Tipologia_inmueble.map((tipo, index) => {
								return (
									<option key={index} value={tipo.tipo}>
										{tipo.tipo}
									</option>
								);
							})}
						</Select>
					</Stack>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Subtipología --'
							name='subtipologiaInmueble'
							value={subtipologia}
							onChange={handleSubtipologiaChange}
						>
							{subtiposDisponibles.map((tipo, index) => {
								return (
									<option key={index} value={tipo.tipo}>
										{tipo.tipo}
									</option>
								);
							})}
						</Select>
					</Stack>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Motivación --'
							name='motivacion'
							onChange={setFiltros}
						>
							<option value='Vender'>Venta</option>
							<option value='Alquilar'>Alquiler</option>
						</Select>
					</Stack>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Orden de creación --'
							name='orden'
							onChange={setFiltros}
						>
							<option value='asc'>Antiguas primero</option>
							<option value='desc'>Recientes primero</option>
						</Select>
					</Stack>
				</Stack>
			</Stack>
		</Center>
	);
};

export default FiltroNoticias;
